import { render, staticRenderFns } from "./edit-interview-quiz.html?vue&type=template&id=044fa3d4&scoped=true&"
import script from "./edit-interview-quiz.js?vue&type=script&lang=js&"
export * from "./edit-interview-quiz.js?vue&type=script&lang=js&"
import style0 from "./edit-interview-quiz.scss?vue&type=style&index=0&id=044fa3d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044fa3d4",
  null
  
)

export default component.exports